import { render } from "./TruckInfo.vue?vue&type=template&id=f0b0e11e&scoped=true"
import script from "./TruckInfo.vue?vue&type=script&lang=js"
export * from "./TruckInfo.vue?vue&type=script&lang=js"

import "./TruckInfo.vue?vue&type=style&index=0&id=f0b0e11e&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0b0e11e"]])

export default __exports__